module.exports = __webpack_public_path__ + "img/bg-sm-2ft.2e391a5d.jpg";